/**
 * @generated SignedSource<<cadda9985b690c2f0add730d0da1c40b>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "roleId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "roleId"
                }
            ],
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RoleGeneralInfoUpdateModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RoleGeneralInfoUpdateModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "0e358b146ee55406d68889fc3f9e2be7",
            "id": null,
            "metadata": {},
            "name": "RoleGeneralInfoUpdateModalQuery",
            "operationKind": "query",
            "text": "query RoleGeneralInfoUpdateModalQuery(\n  $roleId: ID!\n) {\n  role(id: $roleId) {\n    description\n    id\n    name\n  }\n}\n"
        }
    };
})();
node.hash = "5a8dbd3787d1ff59a30a15f5bbaead55";
export default node;
